<script setup lang="ts">
    import useClient from '@composables/useClient';
    import createLegacyUrl from '@/utils/legacyUrls';

    const { client } = useClient();
    await client.logout();

    window.location.href = createLegacyUrl('logout');
</script>
